export const IDENTITY_NAME_MAX_LENGTH = 100
export const DEFAULT_UNKNOWN_IDENTITY_FIELD = 'XXXXX'
const STRICT_BIRTH_IDENTITY_TEXT_FIELDS = ['birthSurname', 'birthFirstName', 'birthPlaceCode'] as const

const DIACRITICS_REGEX = /[\u0300-\u036f]/g
const DISALLOWED_IDENTITY_CHARS_REGEX = /[^A-Z' -]/g
const VALID_IDENTITY_NAME_REGEX = /^[A-Z' -]+$/
const TYPOGRAPHIC_APOSTROPHE_REGEX = /’/g
const MULTIPLE_SPACES_REGEX = /\s+/g
const INS_GIVEN_NAME_SEPARATOR_REGEX = /[\s'\-]+/

export function sanitizeIdentityNameInput(value: string): string {
  return value
    .replace(TYPOGRAPHIC_APOSTROPHE_REGEX, "'")
    .normalize('NFD')
    .replace(DIACRITICS_REGEX, '')
    .toUpperCase()
    .replace(DISALLOWED_IDENTITY_CHARS_REGEX, '')
}

export function isValidIdentityName(value?: string): boolean {
  if (!value) return true
  if (value.length > IDENTITY_NAME_MAX_LENGTH) return false
  return VALID_IDENTITY_NAME_REGEX.test(value.replace(TYPOGRAPHIC_APOSTROPHE_REGEX, "'"))
}

export function normalizeInsGivenNames(value: string): string {
  return sanitizeIdentityNameInput(value).replace(MULTIPLE_SPACES_REGEX, ' ').trim()
}

function getInsGivenNameTokens(value: string): string[] {
  return normalizeInsGivenNames(value).split(INS_GIVEN_NAME_SEPARATOR_REGEX).filter(Boolean)
}

export function isInsBirthGivenPrefixAllowed(birthGivenNames: string, birthFirstName: string): boolean {
  const birthGivenNameTokens = getInsGivenNameTokens(birthGivenNames)
  const birthFirstNameTokens = getInsGivenNameTokens(birthFirstName)

  if (birthGivenNameTokens.length === 0 || birthFirstNameTokens.length === 0) return false
  if (birthFirstNameTokens.length > birthGivenNameTokens.length) return false

  return birthFirstNameTokens.every((token, index) => token === birthGivenNameTokens[index])
}


export function applyBirthIdentityDefaults<T extends Partial<Record<(typeof STRICT_BIRTH_IDENTITY_TEXT_FIELDS)[number], string>>>(
  values: T,
  isINSEnabled: boolean
): T {
  if (!isINSEnabled) return values

  const defaults: Partial<T> = {}
  for (const field of STRICT_BIRTH_IDENTITY_TEXT_FIELDS) {
    if (!values[field]?.trim()) {
      defaults[field] = DEFAULT_UNKNOWN_IDENTITY_FIELD
    }
  }
  return { ...values, ...defaults }
}

export function isProvisionalIdentityValue(value?: string | null): boolean {
  return value === DEFAULT_UNKNOWN_IDENTITY_FIELD
}
